export { BrowserSprite } from "./browser-sprite";
export { BrowserSymbol } from "./browser-symbol";
export { makeIcon } from "./SvgIcon";
export { IconSettingsProvider } from "./IconSettings";

//# sourceMappingURL=index.js.map